import analytics from "helpers/analytics";
import { useEffect } from "react";
import styled from "styled-components";
import mixpanel from "mixpanel-browser";

const PopupContainer = styled.div`
  color: rgb(255, 255, 255);
  background-color: rgba(0, 0, 0, 0.8);
  right: unset;
  left: 3em;
  bottom: 0;
  border-top-left-radius: 0.5em;
  border-top-right-radius: 0.5em;
  font-family: Mulish, sans-serif;
  transition: all 1s ease 0s;
  cursor: pointer;
  padding: 0.5em;
  position: fixed;
  overflow: hidden;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 1.5em;
  display: flex;
  flex-wrap: nowrap;
  z-index: 9999;

  &:hover {
    -webkit-transform: translateY(0em);
    transform: translateY(0em);
  }

  @media screen and (max-width: 1200px) {
    transform: translateY(0em);
  }
`;

const PrivacyPolicyPopup = (props) => {
  const { consent } = props;

  const showPrivacyPopup = () => {
    if (window.ketch != undefined) {
      const ketch = window.ketch;
      ketch("showPreferences");
    }
  };

  useEffect(() => {
    if (consent !== undefined && consent !== null) {
      console.log("Current consent", consent);
      const { C0002 } = consent;
      if (C0002) {
        analytics.enablePlugin("google-tag-manager");
        analytics.enablePlugin("hubspot");
        mixpanel.opt_in_tracking();
      } else {
        analytics.disablePlugin("google-tag-manager");
        analytics.disablePlugin("hubspot");
        mixpanel.opt_out_tracking();
      }
    } else {
      analytics.enablePlugin("google-tag-manager");
      analytics.enablePlugin("hubspot");
      mixpanel.opt_in_tracking();
    }
    console.log("Current analytics state: " + analytics.getState().toString());
  }, [consent]);

  return (
    <PopupContainer onClick={() => showPrivacyPopup()} id="privacy-popup">
      Privacy Preferences
    </PopupContainer>
  );
};

export default PrivacyPolicyPopup;
